import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function PengajuanPinjamBarang() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [valid, setValid] = useState(true);
  const [listLamaCicilan, setListLamaCicilan] = useState([
    { label: "--- Pilih lama cicilan ---", value: "" },
  ])
  const [empBesarPlafond, setEmpBesarPlafond] = useState(0);
  const [settingBiaya, setSettingBiaya] = useState();
  const [empData, setEmpData] = useState([]);
  const [newData, setNewData] = useState({
    plafond: 0,
    lama:0,
    jenis_barang: "",
    spesifikasi: ""
  });


  // CONTROLLER

  const fetchData = async (id) => {
    setIsLoading(true);

      await axios
      .all(
        [
        baseAPI .get(`/v1/user/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/csetting`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const dataUser = res[0].data.data.userData;
        const dataBiaya = res[1].data.data.dataSetting;  
        
        dataBiaya.map(e => {
          if (e.nama_biaya === "Max Harga Barang") {
            setSettingBiaya(e.biaya);
          }
        });
        
        setEmpData(dataUser[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const storeNewPinjaman = async (id) => {

    Swal.fire({
      title: 'Apakah data pengajuan pinjaman barang anda sudah benar?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Ajukan',
      denyButtonText: `Jangan Ajukan`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/detailpinjambarang/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan pinjaman barang berhasil diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            setEmpBesarPlafond(0);
            setNewData({
              plafond: 0,
              lama:0,
              cpokok: 0,
            })
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan pinjaman barang gagal diajukan.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchData(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Silahkan periksa ulang data pengajuan anda.', '', 'info')
      }
    });

  }

  const handleFormat = (plafond, lama) => {

    const numericValue = plafond.replace(/[^0-9]/g, '');
    let rupiahPlafond = parseFloat(numericValue).toLocaleString('id-ID');
    setEmpBesarPlafond(rupiahPlafond);

    if (parseFloat(numericValue) > settingBiaya) {
      Swal.fire({
        icon: 'error',
        title: "Besar estimasi harga barang tidak boleh lebih dari Rp.35.000.000.",
        showConfirmButton: false,
        timer: 1500
      })
      setValid(false);
    } else {
      if (lama > 12 && parseFloat(numericValue) <= 10000000) {
        Swal.fire({
          icon: 'error',
          title: "Lama cicilan lebih dari 9 bulan hanya untuk harga barang di atas Rp.10.000.000.",
          showConfirmButton: false,
          timer: 1500
        });
        setValid(false);
      } else {
        setValid(true);
      }
    }

    if (parseFloat(numericValue) > 10000000) {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
        { label: "24 - Bulan", value: 24 },
        { label: "36 - Bulan", value: 36 },
      ])
    } else if (parseFloat(numericValue) <= 10000000) {
      setListLamaCicilan([
        { label: "3 - Bulan", value: 3 },
        { label: "6 - Bulan", value: 6 },
        { label: "9 - Bulan", value: 9 },
        { label: "12 - Bulan", value: 12 },
      ])
    };
  };
  
  
  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchData(user.id);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Barang</Link> /{' '}
              <Link to='/barang/pengajuanpinjambarang' style={{ color: '#333' }}>Pengajuan Pembelian Barang</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Formulir Pengajuan Pinjaman Barang</b></p>
                <p>Silahkan mengisi formulir pengajuan pinjaman barang berikut untuk mengajukan pinjaman barang.</p>
              </div>

              {/* Estimasi Harga Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Estimasi Harga Barang
                </label>
                <input
                  className='form-control'
                  value={empBesarPlafond !== "NaN" ? "Rp." + empBesarPlafond : "Rp.0"}
                  placeholder="Sebutkan estimasi harga barang anda"
                  onChange={e => {
                    handleFormat(e.target.value, newData.lama)
                    const numericValue = (e.target.value).replace(/[^0-9]/g, '');
                    setNewData({...newData, plafond: parseFloat(numericValue)})
                  }}
                />
              </div>

              {/* Lama cicilan plafond */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Lama Cicilan
                </label>
                <Select
                  isDisabled={empBesarPlafond === 0 || newData.plafond > settingBiaya ? true : false}
                  options={listLamaCicilan}
                  placeholder="Pilih lama cicilan"
                  onChange={e => {
                    handleFormat(empBesarPlafond, e.value);
                    setNewData({...newData, lama: e.value});
                  }}
                />
              </div>

              {/* Tanggal pengajuan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <DatePicker
                  selected={moment().utcOffset(7, true).toDate()}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  readOnly
                  dateFormat="dd/MM/yyyy"
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Jenis Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jenis Barang<span className='text-danger'>*</span>
                </label>
                <input
                  placeholder='Masukan jenis barang'
                  className="form-control"
                  onChange={(e) => setNewData({...newData, jenis_barang: e.target.value})}
                />
              </div>

              {/* Spesifikasi Barang */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Spesifikasi Barang (type, warna, dll)<span className='text-danger'>*</span>
                </label>
                <textarea
                  placeholder='Masukan spesifikasi barang'
                  className="form-control"
                  onChange={(e) => setNewData({...newData, spesifikasi: e.target.value})}
                />
              </div>
              
              <div className='col-md-12'>
                <button
                  disabled={newData.lama !== 0 && newData.plafond !== 0 && newData.jenis_barang !== "" && newData.spesifikasi !== "" && newData.plafond <= settingBiaya && valid === true ? false : true}
                  type="button"
                  className='btn btn-success col-md-12'
                  style={{backgroundColor: "#6A9C89"}}
                  onClick={() => storeNewPinjaman(user.id)}
                >
                  Ajukan
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default PengajuanPinjamBarang;